import { lazy } from 'react';

export const Wallet = lazy(() => import('./Wallet.component'));
